<template>
	<div v-loading.fullscreen.lock="fullscreenLoading">
		<brieHeader bag="#fff" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="xyBox">
				<div class="xyTit">
					{{ perData.name }}
				</div>
				<div class="xyTip">更新时间：{{ perData.updateTime | momentYR('YYYY年MM月DD日') }}</div>
				<iframe class="xyCont" :srcDoc="perData.content" frameborder="0" ref="contentFrame" @load="hideIframeScroll"></iframe>
			</div>
		</div>
	</div>
</template>

<script>
import brieHeader from '@/components/hearder/brieHeader';
export default {
	name: 'userAgreen',
	data() {
		return {
			type: this.$route.query.type || 2,
			fullscreenLoading: false,
			perData: {}
		};
	},
	methods: {
		init() {
			this.fullscreenLoading = true;
			this.$http.get(`api/platform/agreement/${this.type}`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					console.log(res);
					this.perData = res.data;
				}
			});
		},
		hideIframeScroll() {
			try {
				const iframe = this.$refs.contentFrame;
				const doc = iframe.contentDocument || iframe.contentWindow.document;

				// 计算内容高度并设置 iframe 高度
				this.$nextTick(() => {
					try {
						// 方法1: 尝试获取 iframe 内部文档高度
						const body = doc.body;
						const html = doc.documentElement;

						// 获取内容实际高度
						const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

						// 设置 iframe 高度
						if (height > 0) {
							iframe.style.height = height + 'px';
						}
					} catch (innerError) {
						console.warn('无法获取iframe内容高度:', innerError);
						// 方法2: 使用固定方式获取高度
						const resizeObserver = new ResizeObserver((entries) => {
							for (let entry of entries) {
								const height = entry.contentRect.height;
								iframe.style.height = height + 'px';
							}
						});

						// 观察 iframe 内容变化
						resizeObserver.observe(doc.body);
					}
				});
			} catch (e) {
				console.warn('无法访问iframe内容来隐藏滚动条:', e);
			}
		}
	},
	computed: {
		txtType() {
			let val = '';
			switch (Number(this.type)) {
				case 2:
					val = '用户协议';
					break;
				case 3:
					val = '隐私政策';
					break;
				case 4:
					val = '关于我们';
					break;
				case 5:
					val = '联系我们';
					break;
			}
			return val;
		}
	},
	mounted() {
		this.init();
	},
	components: {
		brieHeader
	}
};
</script>
<style lang="scss" scoped>
.xyBox {
	height: calc(100vh - 60px);
	background: #ffffff;
	width: 1200px;
	margin: 0 auto;
	box-sizing: border-box;
	padding-top: 35px;
	margin-top: 10px;
	.xyTit {
		margin: 0 0 22px;
		color: #060606;
		font-size: 22px;
		font-weight: bold;
		text-align: center;
	}
	.xyTip {
		padding-bottom: 35px;
		margin-bottom: 23px;
		border-bottom: 1px solid #efecec;
		color: #8f8f8f;
		font-size: 14px;
		text-align: center;
	}
	.xyCont {
		width: 100%;
	}
}
</style>
